import { SEGMENTS_FAMILY_NAME } from "app/components/widget/widget-utilities/segments/constants";
import { DEFAULT_DURATION_FOR_SEGMENTS, DISABLED_DURATIONS, getShouldHideSegments } from "../utils";

export const UniqueVisitorsGroup = {
    id: "SegmentsUniqueVisitorsGroup",
    properties: {
        order: "3",
        dropdownOrder: 3,
        hasWebSource: true,
        component: "CustomSegments",
        isHidden: getShouldHideSegments,
        mobileWebComponent: "MobileWebSearch",
        viewPermissions: {
            trafficSources: ["Desktop", "Total"],
        },
        title: "folderanalysis.tabs.unique",
        group: "WebsiteAudienceOverview",
        family: SEGMENTS_FAMILY_NAME,
        dashboard: "true",
        compareOnly: "true",
        state: "digitalsuite_segments-analysis-traffic",
        apiController: "CustomSegments",
        webSource: "Desktop",
        totalComponent: "TotalWebCustomSegmentsAnalysis",
        availabilityComponent: "CustomSegments",
        periodOverPeriodSupport: true,
        defaultDuration: DEFAULT_DURATION_FOR_SEGMENTS,
        disabledDurations: DISABLED_DURATIONS,
    },
    widgets: {
        single: {
            defaultType: "SegmentsUniqueVisitorsGroupGraph",
            SegmentsUniqueVisitorsGroupGraph: {
                properties: {
                    options: {
                        showLegend: true,
                    },
                    periodOverPeriodSupport: true,
                },
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    type: "double?",
                    format: "minVisitsAbbr",
                    formatParameter: 3,
                    name: "UniqueVisits",
                    reversed: "False",
                },
                filters: {},
            },
        },
        compare: {
            defaultType: "SegmentsUniqueVisitorsGroupGraph",
            SegmentsUniqueVisitorsGroupGraph: {
                properties: {},
                x_axis: {
                    title: "Date",
                    type: "date",
                    format: "None",
                    name: "Date",
                    reversed: "False",
                },
                y_axis: {
                    type: "double",
                    format: "minVisitsAbbr",
                    formatParameter: 3,
                    name: "UniqueVisits",
                    reversed: "False",
                    yAxisMax: 1,
                },
                filters: {},
            },
        },
    },
};
